export default __webpack_public_path__ + "static/media/bd-booking-large.e6f56229.jpg";